import { getErrorPayload } from '@application/common/helpers/api-helper';
import CreditureApi from '@infrastructure/crediture-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { addSuccessNotification } from '../common/notificationSlice';
export const getCreditureNumberAsync = createAsyncThunk('Creditor/GetIncrimentedCreditorNumber', async (_, { rejectWithValue }) => {
    try {
        const response = await CreditureApi.getCreditureNumber();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createCreditureAsync = createAsyncThunk('Creditor/CreateCreditor', async (supplier, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CreditureApi.createCrediture(supplier);
        dispatch(addSuccessNotification('Leverancier succesvol aangemaakt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateCreditureAsync = createAsyncThunk(`Creditor/Update`, async (supplier, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CreditureApi.updateCrediture(supplier);
        dispatch(addSuccessNotification('Leverancier succesvol aangemaakt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllCreditorsAsync = createAsyncThunk('Creditor/GetAll', async (_, { rejectWithValue }) => {
    try {
        const response = await CreditureApi.getAllCreditors();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllInternCrediteurAsync = createAsyncThunk(`Creditor/GetAllInternCrediteurs`, async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CreditureApi.getAllInternCrediteur(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllExternCrediteurAsync = createAsyncThunk(`Creditor/GetAllExternCrediteurs`, async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CreditureApi.getAllExternCrediteur(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getCreditureByIdAsync = createAsyncThunk(`Creditor/GetByID`, async (Id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CreditureApi.getCreditureById(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createContactPersonAsync = createAsyncThunk('Creditor/CreateContact', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const resposnse = await CreditureApi.createContactPerson(request);
        dispatch(addSuccessNotification('ContactPersoon succesvol aangemaakt'));
        return fulfillWithValue(resposnse.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateContactPersonAsync = createAsyncThunk('Creditor/UpdateContact', async (contactPerson, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CreditureApi.updateContactPerson(contactPerson);
        dispatch(addSuccessNotification('ContactPersoon succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteContactPersonByIdAsync = createAsyncThunk(`Creditor/DeleteContactById`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CreditureApi.deleteContactPersonById(id);
        dispatch(addSuccessNotification(response.data));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getContactPersonsByCreditorIdAsync = createAsyncThunk(`Creditor/GetContactsByCreditorId`, async (creditorId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CreditureApi.getContactPersonsByCreditorId(creditorId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getContactPersonbyIdAsync = createAsyncThunk(`Creditor/GetContactById`, async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CreditureApi.getContactPersonbyId(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllAttachmentsByCreditorIdAsync = createAsyncThunk('Creditor/GetAllAttachmentsByCreditorId', async (creditorId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CreditureApi.getAllAttachmentsByCreditorId(creditorId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const addAttachmentsByCreditorIdAsync = createAsyncThunk('Creditor/UploadCreditorAttachment', async (uploadedFile, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CreditureApi.addAttachmentsByCreditorId(uploadedFile);
        dispatch(addSuccessNotification("Bestand succesvol geüpload"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteCreditorAttachmentAsync = createAsyncThunk('Creditor/DeleteCreditorAttachmentById', async (attachmentId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CreditureApi.deleteCreditorAttachment(attachmentId);
        dispatch(addSuccessNotification("Bijlage succesvol verwijderd"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteCreditureByIdAsync = createAsyncThunk(`Creditor/Delete`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CreditureApi.deleteCreditureById(id);
        dispatch(addSuccessNotification(response.data));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateCreditorToPreferenceAsync = createAsyncThunk('Creditor/UpdateCreditorToPreference', async (updatePreference, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await CreditureApi.updateCreditorToPreference(updatePreference.id, updatePreference);
        dispatch(addSuccessNotification(response.data));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
